"use client";

import React from "react";
import { Brain, Globe, Shield, Briefcase, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Intelligence Algoritmica",
  description: "Analisi profonda dei segnali Yandex YATI per decodificare l'intento di ricerca nel mercato russo.",
  icon: Brain
}, {
  title: "Sovranità Digitale",
  description: "Infrastrutture native e conformità FZ-152 per garantire la massima visibilità nei territori CSI.",
  icon: Globe
}, {
  title: "Protocolli di Sicurezza",
  description: "Protezione dei dati e architetture web blindate per operare con autorità nei corridoi digitali russi.",
  icon: Shield
}, {
  title: "Lead Generation B2B",
  description: "Strategie di conversione ad alto impatto progettate per il settore industriale e tecnologico.",
  icon: Briefcase
}];
export default function TrustQualityValueProposition() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242767" id="authorityblock" className="bg-[#0A0A0F] py-24 md:py-32 overflow-hidden text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-white mb-6 tracking-tighter">
            L'Architettura Umana dietro la Macchina
          </h2>
          <p className="font-default text-lg text-muted-foreground leading-relaxed mb-8">
            RUSSEO non è solo tecnologia; è la fusione tra ingegneria russa e visione strategica europea per dominare il RuNet.
          </p>
          <h3 className="font-default text-2xl md:text-3xl font-semibold text-secondary tracking-tight">
            La Scienza della Conversione CSI (I Nostri Pilastri)
          </h3>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`group transition-all duration-700 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full rounded-none border-white/10 bg-white/5 backdrop-blur-md shadow-lg hover:shadow-2xl hover:border-secondary/80 hover:bg-white/8 transition-all duration-300">
                  <CardHeader className="pb-6">
                    <div className="w-14 h-14 rounded-lg bg-secondary/20 flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-secondary group-hover:text-secondary/80 transition-colors" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl text-white">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="font-default text-base text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className={`mt-16 text-center transition-all duration-1000 delay-500 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="rounded-none bg-secondary text-secondary-foreground hover:bg-secondary/90 font-default font-bold tracking-wide">
            <Link to="/AboutUsPage">
              Esplora la Nostra Intelligence
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}